import { useAsyncDataRequestStatus } from '@/composables/utils/useAsyncDataRequestStatus';
import { useMicroCMSDetailParams } from '@/composables/utils/useMicroCMSDetailParams';
import { useMicroCMSGetListDetail } from '@/wabunka-src/common/composables/query/useMicroCMSClient';
import { createDefaultEnFaqViewModel, type EnFaqResponse, type EnFaqViewModel } from '@/wabunka-src/features/FAQ/models/enFaq';

import type { AsyncDataRequestStatus } from '#app';

/**
 * pathとqueryからdedupe用のkeyの組み立てを行う
 */
const buildKey = (path: string, query?: object) => {
  return path + (query ? ',query=' + JSON.stringify(query) : '');
};

/**
 * FAQの取得に使う Composable
 * Page でのみ使用可能
 */
export const useEnFaq = async () => {
  const { contentId, draftKeyQuery } = useMicroCMSDetailParams();

  const { data, status }: { data: Ref<EnFaqResponse | null>; status: Ref<AsyncDataRequestStatus> } = await useMicroCMSGetListDetail<EnFaqResponse>(
    {
      endpoint: 'en-faq',
      contentId: contentId.value,
      queries: { ...draftKeyQuery?.value },
    },
    {
      key: buildKey('en-faq', { contentId: contentId.value, ...draftKeyQuery?.value }),
      server: true,
    },
  );

  const enFaq = computed<EnFaqViewModel>(() => data.value ?? createDefaultEnFaqViewModel());

  return { enFaq, ...useAsyncDataRequestStatus(status) };
};
